import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IProjectSettingsResponse } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_PROJECT_PERMISSIONS,
  SETTINGS_PROJECT_QUERY_KEY,
  SETTINGS_PROJECT_URL,
} from '../constants';

export default function useSettingsProjectQuery(): IContextQueryResult<IProjectSettingsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IProjectSettingsResponse, Error, IProjectSettingsResponse>({
    queryKey: [SETTINGS_PROJECT_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_PROJECT_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_PROJECT_PERMISSIONS.PROJECTSETTINGS_EDIT,
    }),
  });
}
